export default __webpack_public_path__ + "static/media/wood_art.387f3e6e.png";